import type { MalfunctionSets } from '@ngb-frontend/shared/types'

export const APP_MALFUNCTION_SETS: Readonly<MalfunctionSets> = {
  lighting: [
    'HeadLightNotWorking',
    'DayRunningLightsNotWorking',
    'FrontFogLightsNotWorking',
    'HeadlightHeigthAdjustmentNotWorking',
    'HeadlightLightSensorNotWorking',
    'TailLightsNotWorking',
    'BrakeLightsNotWorking',
    'RearFogLightsNotWorking',
    'ReverseLightsNotWorking',
    'SteeringDirectionIndicatorNotWorking',
    'InteriorLightsNotWorking',
    'OtherLightNotWorking',
  ],
  steering: [
    'VibrationInSteeringWheel',
    'CheckWheelAlignment',
    'CheckSteeringWheelAlignment',
    'SteeringWheelAdjustmentNotWorking',
  ],
  warnings: [
    'TpmsWarningLightOn',
    'OilLightOn',
    'WarningLightOnDashboard',
    'BrakeWarningLightOn',
    'WarningMessageOnDashboard',
    'AirbagWarningLightOn',
  ],
  fluidCheck: [
    'OilCoolantBrakeFluidLevelCheck',
    'AdblueRequired',
    'CoolantLeak',
    'FuelLeak',
    'OilLeak',
    'FluidLeak',
  ],
  climateHeating: [
    'AirConNotWorking',
    'VehicleHeaterNotWorking',
    'SeatHeatingNotWorking',
    'SeatCoolingNotWorking',
    'SteeringWheelHeatingNotWorking',
    'MirrorHeatingNotWorking',
    'WindscreenHeatingNotWorking',
    'RearWindowHeatingNotWorking',
  ],

  otherIssues: [
    'Other',
    'BootBonnetDoorProblem',
    'CarIsOverheating',
    'CarIsSmoking',
    'GearboxNoise',
    'HardToSelectGears',
    'ClutchIssue',
    'NoiseFromEngine',
    'NoiseFromVehicle',
    'SuspensionNoiseKnocking',
    'VehicleInLimpModeOrLossOfPower',
    'BrakesNoisy',
    'PoorBrakes',
    'GloveCompartmentNotOpening',
    'SunRoofIssues',
    'SunRoofNotWorking',
    'OdourFromVehicle',
    'TachometerNotWorking',
    'SpeedometerNotWorking',
    'OdometerNotWorking',
    'SeatAdjustmentNotWorking',
    'SafetyBeltIssues',
  ],
  windscreenWipers: [
    'WipersNotClearing',
    'FrontWipersNotWorking',
    'RearWiperNotWorking',
    'RainSensorNotWorking',
  ],
  electrical: [
    'RemoteKeyNotWorking',
    'MultimediaNotWorking',
    'SatnavSoftwareNotWorking',
    'BatteryFlat',
    'WindowWontOpen',
    'VehicleNotCharging',
    'ChargingIssues',
    'AlarmNotWorking',
    'AlarmIssues',
    'MirrorAdjustmentNotWorking',
    'MirrorFoldingNotWorking',
    'CigaretteLighterNotWorking',
    'PhoneChargingNotWorking',
    'OtherElectricalIssue',
  ],
}

export const APP_MALFUNCTIONS = Object.values(APP_MALFUNCTION_SETS).flat()
